import {createFeatureSelector, createSelector} from '@ngrx/store';
import {allInstanceTypesFeatureKey, State} from '../reducers/all-instance-types.reducer';
import {ClusterInstanceTypeRecord} from '../../../services/api/vocabulary/cluster/instance-types/cluster.instance-type.vocabulary.model';

export const selectAllInstanceTypesState = createFeatureSelector<State>(
  allInstanceTypesFeatureKey
);

export const getAllInstanceTypesRecord = createSelector(
  selectAllInstanceTypesState,
  (state: State): ClusterInstanceTypeRecord[] => state.record
);

export const getAllInstanceTypesLoaded = createSelector(
  selectAllInstanceTypesState,
  (state: State): boolean => state.loaded
);

export const getAllInstanceTypesLoading = createSelector(
  selectAllInstanceTypesState,
  (state: State): boolean => state.loading
);

export const getAllInstanceTypesError = createSelector(
  selectAllInstanceTypesState,
  (state: State): unknown => state.error
);
